import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { Topnavbar } from "./components/topnavbar/topnavbar.component";
import { Navigation } from "./components/navigation/navigation.component";
import { RouterModule } from "@angular/router";
import { appRoutes } from "./app.routes";
import { HomeComponent } from "./pages/home/home.component";
import { CityMaster } from "./pages/master/city_master";
import { CountryMasterComponent } from "./pages/master/country-master/country-master.component";
import { AirlineMasterComponent } from "./pages/master/airline-master/airline-master.component";
import { AirportMasterComponent } from "./pages/master/airport-master/airport-master.component";
// import { CurrencyMasterComponent } from "./pages/master/currency-master/currency-master.component";


// import { CurrencyCountryMasterComponent } from "./pages/master/currency-country-master/currency-country-master.component";
import { VernostServiceService } from "./services/vernost-service.service";
import { ChartsModule } from 'ng2-charts';

import { NgxPaginationModule } from "ngx-pagination";
import { RoleMasterComponent } from "./pages/master/role-master/role-master.component";
import { UserComponent } from "./pages/master/user/user.component";
import { DropdownComponent } from "./master/dropdown/dropdown.component";
import { FunctionalityComponent } from "./pages/functionality/functionality.component";

import { LoginComponent } from "./pages/login/login.component";
import { TaxmasterComponent } from "./pages/master/taxmaster/taxmaster.component";

import { TermsconditionsComponent } from "./pages/master/termsconditions/termsconditions.component";
import { Constants } from "./pages/master/test.constants";
import { CsvUploadService } from "./services/csv-upload.service";
import { FareProductComponent } from "./pages/fare-product-management/fare-product/fare-product.component";

import { CsvUploadServiceInfo } from "./services/csv-uploadinfo.service";
import { RatePerMileComponent } from "./pages/fare-product-management/rate-per-mile/rate-per-mile.component";
// import { BookingDetailsComponent } from "./pages/master/booking-details/booking-details.component";
import { ForgotpasswordComponent } from "./forgotpassword/forgotpassword.component";
import { RecoverpasswordComponent } from "./recoverpassword/recoverpassword.component";
// import { AutoCompleteModule } from "primeng/autocomplete";
import { MultiSelectModule } from 'primeng/multiselect';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SelectModule } from "ng-select";
import { FileUploadModule } from "ng2-file-upload";
// import { ChargemasterComponent } from "./pages/master/chargemaster/chargemaster.component";
import { BannermasterComponent } from "./pages/master/bannermaster/bannermaster.component";
import { FarerulesmasterComponent } from "./pages/master/farerulesmaster/farerulesmaster.component";
import { AirlineExclusionComponent } from "./pages/master/airline-exclusion/airline-exclusion.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";

import { ChangepasswordComponent } from "./components/changepassword/changepassword.component";

import { SsrMasterComponent } from "./pages/master/ssr-master/ssr-master.component";
import { InsuranceProviderMasterComponent } from "./pages/master/insurance-provider-master/insurance-provider-master.component";
import { CryptoService } from "./services/crypto-service.service";




// import { ChangepasswordComponent } from "./components/changepassword/changepassword.component";
import {
  MatButtonModule,
  MatTableModule,
  MatInputModule,
  MatRippleModule,
  MatNativeDateModule,
  MatPaginatorModule
} from "@angular/material";

import { MatDatepickerModule } from "@angular/material";

// import { ReportsComponent } from "./pages/master/reports/reports.component";
import { TinyEditorComponent } from "./tiny-editor/tiny-editor.component";
import { TinyEditorLoginComponent } from "./tiny-editor-login/tiny-editor-login.component";
// import { MemberMilesComponent } from "./pages/master/reports/member-miles/member-miles.component";
// import { CrissReversalComponent } from "./pages/master/reports/criss-reversal/criss-reversal.component";
import { CrissReedemptionComponent } from "./pages/master/reports/criss-reedemption/criss-reedemption.component";
import { PgReportComponent } from "./pages/master/reports/pg-report/pg-report.component";
import { FTRComponent } from "./pages/master/reports/ftr/ftr.component";
import { AncillaryFTRComponent } from "./pages/master/reports/ancillary-ftr/ancillary-ftr.component";

import { Loggerservice } from "./services/logger-service";
import { AuditLogComponent } from "./pages/master/reports/audit-log/audit-log.component";
import { OrderManagementComponent } from "./pages/master/order-management/order-management.component";
import { OrderBookingComponent } from "./pages/master/order-booking/order-booking.component";
import { FareFamilyComponent } from "./pages/supplier-management/fare-family/fare-family.component";
import { MilesConfigureComponent } from "./pages/supplier-management/miles-configure/miles-configure.component";
// import { SelectButtonModule } from "primeng/selectbutton";
import { ExistingBookingsComponent } from "./pages/master/existing-bookings/existing-bookings.component";
import { ToastrModule } from 'ngx-toastr';
import { TPMComponent } from "./pages/master/tpm/tpm.component";
import { GetFareProductComponent } from "./pages/master/get-fare-product/get-fare-product.component";
// import { NgxEditorModule } from 'ngx-editor';
// import { NgxJsonViewerModule } from 'ngx-json-viewer';
// import { LogsComponent } from "./logs/logs.component";
import { UBCONVFEETPMComponent } from "./pages/master/ub-conv-fee-tpm/ub-conv-fee-tpm.component";


import { CancellationMasterComponent } from "./pages/master/cancellation-master/cancellation-master.component";
import { CancelBookingComponent } from "./pages/master/cancel-booking/cancel-booking.component";
// import { CancellationManagementComponent } from "./pages/master/Cancellation-management/Cancellation-management.component";
import { InsuranceMasterComponent } from "./pages/master/insurance-master/insurance-master.component";
import { ManageOfferComponent } from './pages/manage-offer/manage-offer.component';
import { MilesXandYComponent } from './pages/miles-xand-y/miles-xand-y.component';
import { MilesConfigurationComponent } from './pages/miles-configuration/miles-configuration.component';
import { OverridePriceComponent } from './pages/override-price/override-price.component';
import { OfferIdManagementComponent } from './pages/offerId-management/offerId-management.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AncellariesDescriptionComponent } from './pages/master/ancellaries-description/ancellaries-description.component';

import { ConvFeeTpmComponent } from './pages/conv-fee-tpm/conv-fee-tpm.component';
import { PapaParseModule } from 'ngx-papaparse';

// import { CobrandOffersComponent } from "./pages/master/cobrand-offers/cobrand-offers.component";
import { DeltaDataUploadComponent } from './pages/master/delta-data-upload/delta-data-upload.component';
import { CreditShellReportComponent } from './pages/master/reports/credit-shell-report/credit-shell-report.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown-angular7';
import { DsrOneGComponent } from "./pages/supplier-management/dsr-oneg/dsr-oneg.component"
import { HideAncillaries } from './pages/master/hide-ancillaries/hide-ancillaries.component';
import { FcrComponent } from './pages/master/reports/fcr/fcr.component';
import { BannerNewComponent } from './pages/master/banner-new/banner-new.component';
import { SharedButtonComponent } from './components/shared-button/shared-button.component';
import { SharedDatepickerComponent } from './components/shared-datepicker/shared-datepicker.component';
import { SharedHeaderDivComponent } from './components/shared-header-div/shared-header-div.component';
import { SharedInstructDivComponent } from './components/shared-instruct-div/shared-instruct-div.component';
import { EmailFtrComponent } from './pages/master/reports/email-ftr/email-ftr.component';
import { SearchFlightsComponent } from './pages/search-flights/search-flights.component';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { EarnRefundFtrComponent } from './pages/earn-refund-ftr/earn-refund-ftr.component';
import { ExceptionReportComponent } from './pages/master/reports/exception-report/exception-report.component';
@NgModule({
  declarations: [
    TPMComponent,
    UBCONVFEETPMComponent,
    GetFareProductComponent,
    AppComponent,
    Navigation,
    Topnavbar,
    HomeComponent,

    // LogsComponent,
    CityMaster,
    CountryMasterComponent,
    ChangepasswordComponent,
    AirlineMasterComponent,
    AirportMasterComponent,
    // CurrencyMasterComponent,
    // CurrencyCountryMasterComponent,
    //EmailTemplateComponent,
    FareProductComponent,
    RoleMasterComponent,
    UserComponent,
    DropdownComponent,
    FunctionalityComponent,
    LoginComponent,
    TaxmasterComponent,
    TermsconditionsComponent,
    //SmsTemplateComponent,
    RatePerMileComponent,
    ExistingBookingsComponent,
    // BookingDetailsComponent,
    ForgotpasswordComponent,
    RecoverpasswordComponent,
    // ChargemasterComponent,
    BannermasterComponent,
    FarerulesmasterComponent,
    AirlineExclusionComponent,
    // ReportsComponent,
    // CancellationManagementComponent,
    CancelBookingComponent,
    TinyEditorComponent,
    TinyEditorLoginComponent,
    PgReportComponent,
    CrissReedemptionComponent,
    // CrissReversalComponent,
    // MemberMilesComponent,
    FTRComponent,
    AncillaryFTRComponent,
    AuditLogComponent,
    OrderManagementComponent,
    OrderBookingComponent,
    FareFamilyComponent,
    MilesConfigureComponent,
    CancellationMasterComponent,
    InsuranceMasterComponent,
    ManageOfferComponent,
    MilesXandYComponent,
    MilesConfigurationComponent,
    SsrMasterComponent,
    OverridePriceComponent,
    OfferIdManagementComponent,
    InsuranceProviderMasterComponent,
    OfferIdManagementComponent,
    AncellariesDescriptionComponent,

    ConvFeeTpmComponent,


    // CobrandOffersComponent,

    DeltaDataUploadComponent,

	CreditShellReportComponent,
	DsrOneGComponent,
	HideAncillaries,
	FcrComponent,
	BannerNewComponent,
	EmailFtrComponent,
  SharedButtonComponent,
  SharedDatepickerComponent,
  SharedInstructDivComponent,
  SharedHeaderDivComponent,
  SearchFlightsComponent,
  SimpleTableComponent,
  EarnRefundFtrComponent,
  ExceptionReportComponent
  ],

  imports: [
    ToastrModule.forRoot(),
    // SelectButtonModule,
    // NgxJsonViewerModule,
    PapaParseModule,
    ChartsModule,
    MatSelectModule,
    MatFormFieldModule,
    SelectModule,
    BrowserAnimationsModule,
    // AutoCompleteModule,
    MultiSelectModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    NgxPaginationModule,
    FileUploadModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatRippleModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    VernostServiceService,
    Constants,
    CsvUploadService,
    CsvUploadServiceInfo,
    MatDatepickerModule,
    Loggerservice,
    CryptoService,
    DatePipe
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
